__webpack_require__.p = "/games/crash-new/";